import React from 'react';
import { Switch, Route } from 'react-router-dom';

import config, { Project } from 'app.config';
import { permissions } from 'constants/permissions';
import loadablePage from '../loadablePage';
import NotFound from './NotFound';
import PermissionDenied from './PermissionDenied';
import { useUserPermissionMap } from 'hooks/login';

const { publicUrl, project } = config;

const routeConfigs =
  project === Project.SupplyChainManagement
    ? [
        {
          route: '/account/users',
          loadable: loadablePage.general.users,
          permission: permissions.VIEW__ADMIN_USER,
        },
        {
          route: '/account/roles',
          loadable: loadablePage.general.roles,
          permission: permissions.VIEW__ADMIN_ROLE,
        },
        {
          route: '/supplier/suppliers',
          loadable: loadablePage.admin.suppliers,
          permission: permissions.VIEW__ADMIN_SUPPLIER,
        },
        {
          route: '/supplier/skus',
          loadable: loadablePage.general.sku,
          permission: permissions.VIEW__ADMIN_SKU,
        },
        {
          route: '/homepage/announcements',
          loadable: loadablePage.admin.announcements,
          permission: permissions.VIEW__ADMIN_ANNOUNCEMENT,
        },
        {
          route: '/homepage/backlogs',
          loadable: loadablePage.admin.backlog,
          permission: null,
        },
        {
          route: '/order/orders',
          loadable: loadablePage.admin.order,
          permission: permissions.VIEW__ADMIN_ORDER,
        },
        {
          route: '/order/stats',
          loadable: loadablePage.general.stats,
          permission: permissions.VIEW__ADMIN_DASHBOARD,
        },
        {
          route: '/order/returns',
          loadable: loadablePage.admin.return,
          permission: permissions.VIEW__ADMIN_RETURN,
        },
        {
          route: '/supportcase/supportcase',
          loadable: loadablePage.admin.supportcase,
          permission: permissions.VIEW__ADMIN_SUPPORT_CASE,
        },
        {
          route: '/records/(otp-order-download)',
          loadable: loadablePage.admin.records,
        },
      ]
    : project === Project.SuppliersManagement
    ? [
        {
          route: '/account/users',
          loadable: loadablePage.general.users,
          permission: permissions.VIEW__SUPPLIER_USER,
        },
        {
          route: '/account/roles',
          loadable: loadablePage.general.roles,
          permission: permissions.VIEW__SUPPLIER_ROLE,
        },
        {
          route: '/sku/skus',
          loadable: loadablePage.general.sku,
          permission: permissions.VIEW__SUPPLIER_SKU,
        },
        {
          route: '/order/orders',
          loadable: loadablePage.supplier.outbound,
          permission: permissions.VIEW__SUPPLIER_OUTBOUND,
        },
        {
          route: '/order/returns',
          loadable: loadablePage.supplier.return,
          permission: permissions.VIEW__SUPPLIER_RETURN,
        },
        {
          route: '/order/stats',
          loadable: loadablePage.general.stats,
          permission: permissions.VIEW__SUPPLIER_DASHBOARD,
        },
        {
          route: '/supportcase/supportcase',
          loadable: loadablePage.supplier.supportcase,
          permission: permissions.VIEW__SUPPLIER_SUPPORT_CASE,
        },
        {
          route: '/homepage/announcements',
          loadable: loadablePage.supplier.announcements,
          permission: null,
        },
        {
          route: '/homepage/backlogs',
          loadable: loadablePage.supplier.backlog,
          permission: null,
        },
      ]
    : [];

export default function RouteWrapper() {
  const userPermissionMap = useUserPermissionMap();
  return (
    <Switch>
      <Route exact path={`${publicUrl}/`} component={loadablePage.index} />
      {routeConfigs.map(function ({ route, loadable, permission }) {
        return (
          <Route
            key={route}
            path={`${publicUrl}${route}`}
            render={(matchProps) => {
              const Content =
                !permission || userPermissionMap[permission] ? loadable : PermissionDenied;
              return <Content {...matchProps} />;
            }}
          />
        );
      })}
      <Route component={NotFound} />
    </Switch>
  );
}
